import { connect } from 'react-redux';
import {
	formVerificationSetGame,
	resetVerificationForm,
	setClientSeed,
	setNonce,
	setServerSeed,
} from '../../../store/forms/forms.actions';
import { RootState } from '../../../store/configure.store';
import { Verification } from './verification';

const mapStateToProps = (state: RootState) => {
	return {
		bet_verification: state.forms.bet_verification,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setClientSeed: (payload) => dispatch(setClientSeed(payload)),
		setServerSeed: (payload) => dispatch(setServerSeed(payload)),
		setNonce: (payload) => dispatch(setNonce(payload)),
		resetVerificationForm: () => dispatch(resetVerificationForm()),
		setGame: (game) => dispatch(formVerificationSetGame(game)),
	};
};

const VerificationContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(Verification);

export { VerificationContainer };
